
import React, { useEffect, useState } from 'react'

interface OptimizedSplashscreenProps {
  onComplete: () => void
  minDuration?: number
}

const OptimizedSplashscreen = ({ onComplete, minDuration = 1500 }: OptimizedSplashscreenProps) => {
  const [isReady, setIsReady] = useState(false)
  const [fadeOut, setFadeOut] = useState(false)
  const [showContent, setShowContent] = useState(false)

  useEffect(() => {
    // Afficher le contenu après un délai
    const contentTimer = setTimeout(() => {
      setShowContent(true)
    }, 500)

    // Vérifier si les ressources critiques sont chargées
    const checkResourcesLoaded = () => {
      return document.readyState === 'complete'
    }

    const timer = setTimeout(() => {
      if (checkResourcesLoaded()) {
        setIsReady(true)
        setFadeOut(true)
        setTimeout(onComplete, 300) // Animation de sortie
      }
    }, minDuration)

    return () => {
      clearTimeout(timer)
      clearTimeout(contentTimer)
    }
  }, [onComplete, minDuration])

  return (
    <div
      className={`fixed inset-0 z-50 bg-white flex items-center justify-center transition-opacity duration-300 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="text-center">
        <div className="mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-navy-900 mb-8">
            <img 
              src="/lovable-uploads/ffdc9e9e-d5a3-441c-800f-1f3ad804bb3e.png"
              alt="Julycia Kiyal Logo"
              className="w-12 h-12 object-contain brightness-0 invert"
              loading="eager"
            />
          </div>
        </div>

        <div className={`transition-all duration-1000 ${
          showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h1 className="text-4xl font-sans font-light text-navy-900 mb-4">
            <span className="text-navy-900">JULYCIA</span>
            <span className="text-blue-600 ml-2 font-semibold">KIYAL</span>
          </h1>
          <p className="text-navy-600 font-light">
            Consultante Communication & Branding
          </p>
        </div>

        {/* Indicateur de chargement optimisé */}
        <div className={`mt-8 transition-opacity duration-300 ${
          isReady ? 'opacity-0' : 'opacity-100'
        }`}>
          <div className="w-8 h-8 border-2 border-pink-200 border-t-pink-600 rounded-full mx-auto animate-spin" />
        </div>
      </div>
    </div>
  )
}

export default OptimizedSplashscreen
